import axios from 'axios'

export const axiosErrorHandler = (e: unknown): void => {
  if (axios.isAxiosError(e)) {
    if (e.response)
      console.error(
        `ERROR code : ${e.response.status} - data : ${JSON.stringify(
          e.response.data,
        )} - headers : ${JSON.stringify(e.response.headers)}`,
      )
    else if (e.request) console.error(JSON.stringify(e.request))
    else console.error(JSON.stringify(e.message))
  }
}
